module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Rainbow-ea9872ffb545ea16cb33f42ba0c05d3e.svg";